<?xml version="1.0" encoding="UTF-8"?>
<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>Form Elements/Checkbox/x/partly_select/18</title>
    <desc>Created with Sketch.</desc>
    <g id="Form-Elements/Checkbox/x/partly_select/18" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polygon id="Path-3" fill="#FFFFFF" fill-rule="nonzero" points="14 8 14 10 4 10 4 8"></polygon>
    </g>
</svg>